import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { PointInfoModelDiscriminator as PointInfoViewModelpointInfoDiscriminator } from 'autogen/swagger/all';
import { MatasPlusPoints } from 'autogen/translation-keys/trans-website-points';
import { format } from 'modules/helpers/strings';
import { SubscriptionContext } from '../hooks/context';
import { type PlusPoints, type Points, PointText, StandardPoints } from './Points';

const PointTextChanel = styled(PointText)`
    .color-matas-plus,
    b {
        color: black;
    }
`;

function PlusPointsChanel({ pointsModel, overwritePoints }: PlusPoints) {
    const { subscriptionActive } = useContext(SubscriptionContext);
    const { t } = useTranslation();
    const pointsBefore =
        subscriptionActive && overwritePoints ? overwritePoints.pointsBefore : pointsModel.pointsBefore;
    const pointsAfter = subscriptionActive && overwritePoints ? overwritePoints.pointsAfter : pointsModel.pointsAfter;
    const pointsText = format(t(MatasPlusPoints))(pointsBefore, pointsAfter);

    return <PointTextChanel text={pointsText} />;
}

export default function PointsChanel({ points, overwritePoints }: Points) {
    return PointInfoViewModelpointInfoDiscriminator(
        points.pointInfo,
        (model) => (
            <StandardPoints
                pointsModel={model}
                overwritePoints={overwritePoints?.pointInfo as StandardPoints['overwritePoints']}
            />
        ),
        (model) => (
            <PlusPointsChanel
                pointsModel={model}
                overwritePoints={overwritePoints?.pointInfo as PlusPoints['overwritePoints']}
            />
        ),
        () => <></>
    );
}
